var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgManage = function SvgManage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "manage",
    width: 18.308,
    height: 17,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.308 16.346a.654.654 0 0 1-.654.654h-17A.654.654 0 0 1 0 16.346V.654C0 .293.293 0 .654 0h17c.361 0 .654.293.654.654v15.692ZM17 5.931v-.7H1.308v10.461H17V5.931Zm0-4.623H1.308v2.615H17V1.308ZM2.942 3.269a.654.654 0 1 1 0-1.307.654.654 0 0 1 0 1.307Zm2.289 0a.654.654 0 1 1 0-1.307.654.654 0 0 1 0 1.307Zm2.288 0a.654.654 0 1 1 0-1.307.654.654 0 0 1 0 1.307Z",
    fill: "#264D6D",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgManage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/manage.5b4dcff2.svg";
export { ForwardRef as ReactComponent };